import { useId, useEffect, ReactNode, useContext, useState } from "react";
import { GEBAEUDE_TYP_OPTIONS, PropertiesAutoFillState } from "../../state/types.ts";
import SelectionInput from "./input-select.tsx";
import { useStore } from "../../state/state.ts";
import { ConfigContext } from "../../config_context.ts";

export default function InputSelectGebaeudetyp (){
  const [auto_filled, set_auto_filled] = useState<PropertiesAutoFillState | undefined>(PropertiesAutoFillState.Estimated);
  const gebaeude_typ = useStore((state)=>state.gebaeude_typ);
  const set_property = useStore((state)=>state.set_property);
  const gebaeude_typ_options_filter = useContext(ConfigContext).gebaeude_typ_options;
  const filtered_gebaeude_typ_options = gebaeude_typ_options_filter
      ? GEBAEUDE_TYP_OPTIONS.filter(o => gebaeude_typ_options_filter.includes(o.value))
      : GEBAEUDE_TYP_OPTIONS;          
  const options_with_default = [{label: "Gebäudetyp auswählen", value:''}, ...filtered_gebaeude_typ_options];
    
    return <SelectionInput 
      auto_filled={auto_filled}
      label={"Gebäudetyp"} 
      value={gebaeude_typ} 
      hint="Bitte Gebäudetyp auswählen"
      validate={async (value)=>(value!="")}
      options={options_with_default}
      onChange={(value) => {
        console.log("gebaeude_typ", value == "" ? undefined : value);
        set_property('gebaeude_typ', value);
        set_auto_filled(undefined);
      }} />
}
